<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu danh sách kết quả xử lý đã gửi lên CSDLQG</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị tạo:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption" ref="unitTree"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Thuộc Bộ/Tỉnh:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<unit-tree :cached="true" v-model="searchForm.issuedUnitId" ref="unitTree"></unit-tree>-->
                                    <top-level-unit :cached="true" v-model="searchForm.issuedUnitId" allowClear="true"></top-level-unit>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Số QĐ phê duyệt PAXL:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.decisionNumber" placeholder="Nhập số quyết định ..."></b-form-input>
                                </b-form-group>
                                <b-form-group label="Quyết định từ ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.decisionStartDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Chức danh người QĐ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input v-model="searchForm.deciderTitle" placeholder="Nhập chức danh người QĐ  ..." style="width:100%"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Đến ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.decisionEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col md="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="data/national-public-asset-handlings"
                            gridName="Danh sách kết quả xử lý"
                            ref="nationalPublicAssetHandlingsTable">
                        <!--<template v-slot:actions v-if="hasDeletePermission">
                            <b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>
                        </template>-->
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.item.syncSourceType) }}
                        </template>
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(handlingDate)="row">
                            {{ row.item.handlingDate | formatDate }}
                        </template>
                        <template v-slot:cell(decisionDate)="row">
                            {{ row.item.decisionDate | formatDate }}
                        </template>
                        <template v-slot:cell(handlingCost)="row">
                            {{ row.item.handlingCost | currency }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewNationalPublicAssetHandlingDecisionResult'])" size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="isDataOwner(row.item)" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListSyncedNationalPublicAssetHandlings',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    code: null,
                    name: null,
                    decisionNumber: null,
                    decisionStartDate: null,
                    decisionEndDate: new Date().formatDate(),
                    issuedUnitId: this.getTopLevelUnitIdCache(),
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    decider: null,
                    hasHandlingResults: true,
                },
                gridOptions: {
                    fields: [
                        { key: 'decisionNumber', label: 'Số QĐ phê duyệt PAXL', sortable: true, sortDirection: 'asc' },
                        { key: 'decisionDate', label: 'Ngày quyết định', sortable: true, sortDirection: 'asc' },
                        { key: 'deciderTitle', label: 'Chức danh người QĐ', sortable: true, sortDirection: 'asc' },
                        { key: 'issuedUnitName', label: 'Thuộc Bộ/Tỉnh', sortable: true, sortDirection: 'asc' },
                        { key: 'unitName', label: 'Đơn vị tạo', sortable: true, sortDirection: 'asc', groupable: true },
                    ],
                    sortBy: 'decisionNumber',
                    sortDesc: true
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            ...mapState({
                listSyncSourceTypes: (state) => state.common.listSyncSourceTypes
            }),
            hasDeletePermission() {
                return this.authorize(['ManageNationalPublicAssetHandlingDecisionResult']);
            }
        },
        created() {
            //this.searchForm.handlingUnitId = this.$store.state.identity.unitId;
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.nationalPublicAssetHandlingsTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.nationalPublicAssetHandlingsTable.refresh();
            },
            isDataOwner(row) {
                return this.authorize(['ManageNationalPublicAssetHandlingDecisionResult'], row.syncUnitId);
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa kết quả xử lý tài sản này?')) {
                    this.$services.delete(`data/national-public-asset-handlings/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa kết quả xử lý tài sản thành công');
                        vm.search();
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.nationalPublicAssetHandlingsTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các kết quả xử lý tài sản này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/national-public-asset-handlings?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các kết quả xử lý tài sản thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn kết quả xử lý tài sản cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
